// Step indexes of the CustomPosts wizard; My Niche Video inserts a Topic & script step,
// so every site reads them from here. -1 means the flow has no such step. `review` is
// past the last step in the captioned flows: Schedule is final.
export interface WizardFlow {
    isTextOnly: boolean;
    isManualFlow: boolean;
    postCaptionedVideo: boolean;
    isNicheVideo: boolean;
}

export interface WizardStepIndexes {
    total: number;
    topic: number;
    media: number;
    schedule: number;
    review: number;
}

export const wizardSteps = (flow: WizardFlow): WizardStepIndexes => {
    // Basic → Platforms → Topic & script → Record → Schedule.
    if (flow.isNicheVideo) return { total: 5, topic: 2, media: 3, schedule: 4, review: -1 };
    // Basic → Platforms → Content → Schedule → Review (no media step).
    if (flow.isTextOnly) return { total: 5, topic: -1, media: -1, schedule: 3, review: 4 };
    // Basic → Platforms → Content → Media → Schedule → Review.
    if (flow.isManualFlow) return { total: flow.postCaptionedVideo ? 5 : 6, topic: -1, media: 3, schedule: 4, review: 5 };
    // Basic → Platforms → Media → Schedule → Review.
    return { total: flow.postCaptionedVideo ? 4 : 5, topic: -1, media: 2, schedule: 3, review: 4 };
};
